import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  ...stateAbstract,
  invoicesDetail: {},
  invoicesCount: null,
  invoicesList: [],
  debitnotesDetail: {},
  debitnotesCount: null,
  debitnotesList: [],
  creditnotesDetail: {},
  creditnotesCount: null,
  creditnotesList: [],
  cessionsCount: null,
  cessionsList: [],
  sequencesDetail: {},
  sequencesCount: null,
  sequencesList: []
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
